import config from './index';

export default function (type) {
  if (config.MessageFormByContentType[type]) {
    return config.MessageFormByContentType[type];
  }
  return config.MessageFormByContentType.default || config.MessageForm;
}
